import { useSelector } from "react-redux";

import type { RootState } from "../../../store";
import type { UUID } from "../../../utils";

export const useAuthCustomerIdSelector = (): UUID | null =>
  useSelector((state: Pick<RootState, "auth">) => state.auth.customerId);
